import { useState, useEffect } from "react";

export default function TypewriterText({
  text = "Better Insights",
  typingSpeed = 80,
  deletingSpeed = 40,
  pauseTime = 1500,
}) {
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let timer;

    if (!isDeleting && index < text.length) {
      timer = setTimeout(() => {
        setDisplayText(text.slice(0, index + 1));
        setIndex(index + 1);
      }, typingSpeed);
    }

    else if (!isDeleting && index === text.length) {
      timer = setTimeout(() => setIsDeleting(true), pauseTime);
    }

    else if (isDeleting && index > 0) {
      timer = setTimeout(() => {
        setDisplayText(text.slice(0, index - 1));
        setIndex(index - 1);
      }, deletingSpeed);
    }

    else if (isDeleting && index === 0) {
      setIsDeleting(false);
    }

    return () => clearTimeout(timer);
  }, [index, isDeleting, text, typingSpeed, deletingSpeed, pauseTime]);

  return (
    <span>
      {displayText}
      <span className="cursor">|</span>
    </span>
  );
}